import { FC, useState } from 'react';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import AuthWrapper from '../../common/AuthWrapper';
import CustomInput from '../../common/CustomInput';
import CustomButton from '../../common/CustomButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import { useResetPasswordInitiateMutation } from '../../store/services/authApi';

import styles from './ForgotPassword.module.scss';

const ForgotPassword: FC = () => {
  const isMobile = useIsMobile();
  const [resetPasswordInitiate] = useResetPasswordInitiateMutation();

  const [success, setSuccess] = useState(false);
  const [resErrors, setResErrors] = useState<{attr: string | null, code: string, detail: string}[] | null>(null);

  const initialValues = {
    email: '',
  };

  const handleSubmit = async (values: { email: string }) => {
    try {
      await resetPasswordInitiate({email: values.email});
      setResErrors(null);
      setSuccess(true);
    } catch (error) {
      console.error(error);
      setSuccess(false);
      setResErrors((error as any)?.data?.errors || null);
    }
  };

  const formikValidate = (values: { email: string }) => {
    const errors: { email?: string } = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = 'Invalid email address';
    }
    return errors;
  }

  return (
    <AuthWrapper btnName='Sign In'>
      <Box className={styles.loginContent}>
        <Typography variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`} className={styles.title}>Forgot your password?</Typography>
        <Formik
          initialValues={initialValues}
          validate={formikValidate}
          onSubmit={handleSubmit}
        >
          {({ values, errors, handleChange, isSubmitting }) => (
            <Form className={styles.loginForm}>
              <CustomInput
                inputType='email'
                inputName="email"
                value={values.email}
                error={errors.email}
                customClass={styles.customInput}
                onChange={handleChange}
              />
              <CustomButton
                btnType='submit'
                customClass={styles.customButton}
                disabled={isSubmitting}
              >
                Reset Password
              </CustomButton>
              {success && <Typography variant='h12' sx={{ color: '#208B64' }}>
                Check your email for a reset link.
              </Typography>}
              {resErrors && resErrors.map((error, index) => (
                <Typography key={index} variant='h12' sx={{ color: '#C8102E' }}>
                  {error.detail}
                </Typography>
              ))}
            </Form>)}
        </Formik>

        <Box className={styles.signInQuestion}>
          <Typography variant='h11' className={styles.signInQuestionText}>Remembered your password?</Typography>
          <Link to='/' className={styles.signInLink}>
            <Typography variant='h11Semibold'>Login</Typography>
          </Link>
        </Box>
      </Box>
    </AuthWrapper>
  )
};

export default ForgotPassword